export default {
  methods: {

    set_LocalValues(){

      // DataItems
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.cutoff = this.Queries.SQL1[0].CUTOFF

      // Json
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.revision = json.revision
      this.area     = json.area
      this.table    = json.table
      this.columns  = json.columns
      this.scroll   = json.scroll
      this.sundries = json.sundries

      this.filterData = this.rawData
      this.gmx_tableCoordinates('x', this.columns, 5)
      this.table.width = this.columns[this.columns.length-1].ex

      // Current
      this.current = {idx: '1', blk: 'EN112'}

      let last = this.filterData.findLast(f=>f.ASD)
      if(last) {
        this.current.idx = last.SN
        this.current.blk = last.ER_BK
      }


      // Scroll Bar
      this.scroll.bar = {...json.scroll.bar,
        y: 0,
        size: null,
        ratio: null,
        space: null,
      }
      this.scroll.viewbox = {...json.scroll.viewbox,
        space: null,
      }
      this.scroll.content = {
        y: 0,
        height: null,
      }
    },


    set_ScrollValues() {
      // Scroll Pre-Proceassing
      this.scroll.bar.size = this.scroll.viewbox.height / this.scroll.content.height * this.scroll.viewbox.height
      this.scroll.viewbox.space = this.scroll.content.height - this.scroll.viewbox.height
      this.scroll.bar.space = this.scroll.viewbox.height - this.scroll.bar.size
    },

  }
}